// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInboxMarkReadBody = {
  inboxItemIds: string[];
};

export type typeInboxMarkReadOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { markedCount: number; unreadCount: number };
};

export type typeInboxMarkReadOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxMarkReadOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxMarkReadOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInboxMarkReadBody = {
  type: "object",
  properties: {
    inboxItemIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["inboxItemIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInboxMarkRead(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInboxMarkReadBody);
  }

  return async function postInboxMarkRead(
    payload: typeInboxMarkReadBody,
  ): Promise<typeInboxMarkReadOutput200 | typeInboxMarkReadOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInboxMarkRead" failed before calling the network. #83d6a218f1a5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#83d6a218f1a5" },
        },
        data: null,
      } as typeInboxMarkReadOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/inbox/mark-read`,
      httpMethod: "POST",
      options,
    })) as typeInboxMarkReadOutput200 | typeInboxMarkReadOutput400;
  };
}
